var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social",class:{
        'large': _vm.size === 'lg',
        'small': _vm.size === 'sm',
        'bordered': _vm.type === 'bordered'
    }},[_c('Icon',{attrs:{"icon":_vm.icon}}),(_vm.followers)?_c('p',{staticClass:"social__text"},[_vm._v(_vm._s(_vm.followers)+" Followers")]):_vm._e(),(_vm.subscribers)?_c('p',{staticClass:"social__text"},[_vm._v(_vm._s(_vm.subscribers)+" Subscribers")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }